import React from 'react';
import ComingSoon from './ComingSoon.jsx';
import Subscription from '../Subscription Plan/Subscriptionhistory.jsx'
import { useEffect } from "react";

const ProfileSubscriptionHistory = () => {
  useEffect(() => {
      window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
    }, []);
  return <Subscription />;
};

export default ProfileSubscriptionHistory;
